// utils/mathServerHttp.js

import { getNavigate } from './navigateService';

/**
 * 封装的通用 fetch 请求函数
 * @param {string} url 请求的 URL
 * @param {object} options fetch 的选项
 * @returns {Promise<any>} 响应的数据
 */
export async function fetchMathApiWithAuth(url, options = {}) {
    try {
        const response = await fetch(url, options);

        const navigate = getNavigate();
        if (response.status === 401) {
            navigate('/'); // 未授权时跳转到登录页面
            return;
        }

        if (!response.ok) {
            throw new Error('系统繁忙，请稍后重试');
        }

        const result = await response.json();
        if (result.resultCode !== "success") {
            throw new Error(result.message);
        }

        return result.data;
    } catch (error) {
        console.error(`请求失败: ${error.message}`);
        throw error;
    }
}

export async function fetchMathApiNoAuth(url, options = {}) {
    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error('系统繁忙，请稍后重试');
        }

        const result = await response.json();
        if (result.resultCode !== "success") {
            throw new Error(result.message);
        }

        return result.data;
    } catch (error) {
        console.error(`请求失败: ${error.message}`);
        throw new Error('系统繁忙，请稍后重试');
    }
}
